import { Button } from '@mui/material';
import React, { useState } from 'react';
import AuxDataApi from '../../api/AuxDataApi';
import { handleUnauthorizedResponse } from '../../api/http';
import { AuthData } from '../../context/auth';
import { withAuxDataContext } from '../../context/auxData';
import { ErrorData } from '../../context/ErrorProvider';
import { AuxDataSetCreateRequest, AuxDataUITypes } from '../../types/auxData';
import { successToast } from '../Toast';
import AuxDataModal from './AuxDataModal';

interface Props {
	authData: AuthData;
	errorData: ErrorData;
	entityLocator: string;
	editKey: string;
	editValue: string;
	onConfirmCallback: () => Promise<void>;
}

const AuxDataEditModalTrigger = (props: Props) => {
	const {
		authData,
		errorData,
		entityLocator,
		editKey,
		editValue,
		onConfirmCallback,
	} = props;
	const [isOpen, setIsOpen] = useState(false);
	const close = () => setIsOpen(false);
	const open = () => setIsOpen(true);

	const handleEditAuxData = async (key: string, value: string) => {
		const params: AuxDataSetCreateRequest = {
			auxData: [
				{
					key,
					value,
					uiType: AuxDataUITypes.normal,
				},
			],
		};

		try {
			await AuxDataApi.createAuxData(
				authData.auth.authorizationToken,
				params,
				entityLocator,
			);
			await onConfirmCallback();
			successToast('Aux data updated');

			return true;
		} catch (error) {
			errorData.handleErrorResponse(error, 'Failed to update aux data');
			await handleUnauthorizedResponse(error, authData);

			return false;
		}
	};

	return (
		<>
			<Button onClick={open} size='small'>
				Edit
			</Button>
			<AuxDataModal
				close={close}
				isOpen={isOpen}
				title={'Edit Aux Data'}
				entityLocator={entityLocator}
				editKey={editKey}
				editValue={editValue}
				handleConfirm={handleEditAuxData}
			/>
		</>
	);
};

export default withAuxDataContext<Props>(AuxDataEditModalTrigger);
